import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import {
  CARD_ARRAY,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
export default function Lucky7A() {
  const GAME_ID = "LUCKY7";
  const VIDEO_ID = 3056;
  const [showRules, setShowRules] = React.useState(false);
  const dispatch = useDispatch();
  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );
  const lastTenResultData = useQuery(
    "getResult",
    () => getCasinoLastTenResultAPI(GAME_ID),
    {
      refetchInterval: 1500,
    }
  );
  const casinoBets = useQuery("casinoBets", () => getCasinoBetsAPI(GAME_ID), {
    refetchInterval: 2500,
  });
  const [casinoPlData, setCasinoPlData] = useState([]);
  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);
  const [selectedTab, setSelectedTab] = React.useState("game");
  return (
    // <div className="center-main-container casino-page ng-tns-c3502172659-1 ng-star-inserted">
    //   <div className="center-container ng-tns-c3502172659-1">
    //     <div className="casino-page-container ng-tns-c3502172659-1 lucky7a">
    //       <div className="casino-title-header-mobile d-xl-none ng-tns-c3502172659-1">
    //         <ul className="nav nav-tabs menu-tabs ng-tns-c3502172659-1">
    //           <li
    //             onClick={() => setSelectedTab("game")}
    //             className="nav-item ng-tns-c3502172659-1"
    //           >
    //             <div
    //               className={
    //                 selectedTab == "game"
    //                   ? "ng-tns-c3502172659-1 nav-link active"
    //                   : "ng-tns-c3502172659-1 nav-link"
    //               }
    //             >
    //               Game
    //             </div>
    //           </li>
    //           <li
    //             onClick={() => setSelectedTab("bet")}
    //             className="nav-item ng-tns-c3502172659-1"
    //           >
    //             <div
    //               className={
    //                 selectedTab == "game"
    //                   ? "ng-tns-c3502172659-1 nav-link active"
    //                   : "ng-tns-c3502172659-1 nav-link"
    //               }
    //             >
    //               {" "}
    //               Placed Bet ({casinoBets?.data?.response?.length}){" "}
    //             </div>
    //           </li>
    //         </ul>
    //         <div className="pe-2 ng-tns-c3502172659-1">
    //           <span className="casino-rid ng-tns-c3502172659-1">
    //             <a
    //               className="d-block ng-tns-c3502172659-1"
    //               onClick={() => {
    //                 setShowRules(true);
    //               }}
    //             >
    //               <small className="ng-tns-c3502172659-1">Rules</small>
    //             </a>{" "}
    //             Round ID:{" "}
    //             <span className="ng-tns-c3502172659-1 ng-star-inserted">
    //               {casinoData?.data?.response?.marketId}
    //             </span>
    //           </span>
    //         </div>
    //       </div>
    //       <div className="casino-header ng-tns-c3502172659-1">
    //         <span className="casino-name ng-tns-c3502172659-1">
    //           {" "}
    //           Lucky 7 - A
    //           <a
    //             className="ms-1 d-xl-inline d-none ng-tns-c3502172659-1"
    //             onClick={() => {
    //               setShowRules(true);
    //             }}
    //           >
    //             <small className="ng-tns-c3502172659-1">Rules</small>
    //           </a>
    //         </span>
    //         <span className="casino-rid d-none d-xl-inline-block ng-tns-c3502172659-1">
    //           <small className="ng-tns-c3502172659-1">
    //             Round ID:{" "}
    //             <span className="ng-tns-c3502172659-1 ng-star-inserted">
    //               {casinoData?.data?.response?.marketId}
    //             </span>
    //           </small>
    //         </span>
    //       </div>

    //       {selectedTab == "game" ? (
    //         <div className="ng-tns-c3502172659-1 ng-star-inserted">
    //           <div className="casino-video ng-tns-c3502172659-1">
    //             <div className="video-box-container ng-tns-c3502172659-1">
    //               <div className="casino-video-box ng-tns-c3502172659-1 ng-star-inserted">
    //                 <CasinoVideo id={CASINO_VIDEO.lucky7A} />
    //               </div>
    //             </div>
    //             <div className="ng-tns-c3502172659-1 ng-star-inserted">
    //               <div
    //                 _ngcontent-ng-c1798067373=""
    //                 className="casino-video-cards ng-tns-c1798067373-0 ng-star-inserted"
    //               >
    //                 <div
    //                   _ngcontent-ng-c1798067373=""
    //                   className="flip-card-container ng-tns-c1798067373-0"
    //                 >
    //                   {casinoData?.data?.response?.cards &&
    //                     casinoData?.data?.response?.cards[0]?.map((item) => (
    //                       <div
    //                         _ngcontent-ng-c1798067373=""
    //                         className="me-lg-2 me-1 ng-tns-c1798067373-0 ng-star-inserted"
    //                       >
    //                         <img
    //                           _ngcontent-ng-c1798067373=""
    //                           className="ng-tns-c1798067373-0"
    //                           src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.png`}
    //                         />
    //                       </div>
    //                     ))}
    //                 </div>
    //               </div>
    //             </div>

    //             <Timer value={casinoData?.data?.response?.autoTime} />
    //           </div>

    //           <div className="casino-detail ng-tns-c3502172659-1">
    //             <div className="casino-table ng-tns-c3502172659-1 ng-star-inserted">
    //               <div className="casino-table-full-box ng-tns-c3502172659-1">
    //                 <div className="lucky7low ng-tns-c3502172659-1 ng-star-inserted">
    //                   <div className="casino-odds text-center ng-tns-c3502172659-1">
    //                     {getOddForEntity("LOW card", casinoData)}
    //                   </div>
    //                   <div
    //                     onClick={() => setBet("LOW card", casinoData, dispatch)}
    //                     className={`ng-tns-c3502172659-1 back casino-odds-box casino-odds-box-theme ${casinoData
    //                       ?.data?.response?.autoTime < 5 && "suspended-box"}`}
    //                   >
    //                     <span className="casino-odds ng-tns-c3502172659-1">
    //                       {" "}
    //                       LOW Card
    //                     </span>
    //                   </div>
    //                   <div className="casino-nation-book text-center ng-tns-c3502172659-1">
    //                     {getCasinoPlExposureByRunner(casinoPlData, "LOW card")}
    //                   </div>
    //                 </div>

    //                 <div className="lucky7 ng-tns-c3502172659-1 ng-star-inserted">
    //                   <img
    //                     className="ng-tns-c3502172659-1"
    //                     src="https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/7.png"
    //                   />
    //                 </div>

    //                 <div className="lucky7high ng-tns-c3502172659-1 ng-star-inserted">
    //                   <div className="casino-odds text-center ng-tns-c3502172659-1">
    //                     {getOddForEntity("HIGH card", casinoData)}
    //                   </div>
    //                   <div
    //                     onClick={() =>
    //                       setBet("HIGH card", casinoData, dispatch)
    //                     }
    //                     className={`ng-tns-c3502172659-1 back casino-odds-box casino-odds-box-theme ${casinoData
    //                       ?.data?.response?.autoTime < 5 && "suspended-box"}`}
    //                   >
    //                     <span className="casino-odds ng-tns-c3502172659-1">
    //                       HIGH Card
    //                     </span>
    //                   </div>
    //                   <div className="casino-nation-book text-center ng-tns-c3502172659-1">
    //                     {getCasinoPlExposureByRunner(casinoPlData, "HIGH card")}
    //                   </div>
    //                 </div>

    //                 <div className="min_max_odds ng-tns-c3502172659-1 ng-star-inserted">
    //                   <span className="min_max_span ng-tns-c3502172659-1">
    //                     <b className="ng-tns-c3502172659-1">Min:</b>
    //                     <span className="ng-tns-c3502172659-1"> 100</span>
    //                   </span>
    //                   <span className="min_max_span ng-tns-c3502172659-1">
    //                     <b className="ng-tns-c3502172659-1">Max:</b>
    //                     <span className="ng-tns-c3502172659-1">
    //                       <span className="ng-tns-c3502172659-1 ng-star-inserted">
    //                         {" "}
    //                         100000{" "}
    //                       </span>
    //                     </span>
    //                   </span>
    //                 </div>
    //               </div>
    //               <div className="casino-table-box mt-3 ng-tns-c3502172659-1">
    //                 <div className="casino-table-left-box ng-tns-c3502172659-1">
    //                   <div className="lucky7odds ng-tns-c3502172659-1 ng-star-inserted">
    //                     <div className="casino-odds text-center ng-tns-c3502172659-1">
    //                       {getOddForEntity("even", casinoData)}
    //                     </div>
    //                     <div
    //                       onClick={() => setBet("even", casinoData, dispatch)}
    //                       className={`ng-tns-c3502172659-1 back casino-odds-box casino-odds-box-theme ${casinoData
    //                         ?.data?.response?.autoTime < 5 && "suspended-box"}`}
    //                     >
    //                       <span className="casino-odds ng-tns-c3502172659-1">
    //                         Even
    //                       </span>
    //                     </div>
    //                     <div className="casino-nation-book text-center ng-tns-c3502172659-1">
    //                       {getCasinoPlExposureByRunner(casinoPlData, "Even")}
    //                     </div>
    //                   </div>

    //                   <div className="lucky7odds ng-tns-c3502172659-1 ng-star-inserted">
    //                     <div className="casino-odds text-center ng-tns-c3502172659-1">
    //                       {getOddForEntity("odd", casinoData)}
    //                     </div>
    //                     <div
    //                       onClick={() => setBet("odd", casinoData, dispatch)}
    //                       className={`ng-tns-c3502172659-1 back casino-odds-box casino-odds-box-theme ${casinoData
    //                         ?.data?.response?.autoTime < 5 && "suspended-box"}`}
    //                     >
    //                       <span className="casino-odds ng-tns-c3502172659-1">
    //                         Odd
    //                       </span>
    //                     </div>
    //                     <div className="casino-nation-book text-center ng-tns-c3502172659-1">
    //                       {getCasinoPlExposureByRunner(casinoPlData, "Odd")}
    //                     </div>
    //                   </div>

    //                   <div className="min_max_odds ng-tns-c3502172659-1 ng-star-inserted">
    //                     <span className="min_max_span ng-tns-c3502172659-1">
    //                       <b className="ng-tns-c3502172659-1">Min:</b>
    //                       <span className="ng-tns-c3502172659-1"> 100</span>
    //                     </span>
    //                     <span className="min_max_span ng-tns-c3502172659-1">
    //                       <b className="ng-tns-c3502172659-1">Max:</b>
    //                       <span className="ng-tns-c3502172659-1">
    //                         <span className="ng-tns-c3502172659-1 ng-star-inserted">
    //                           {" "}
    //                           25000{" "}
    //                         </span>
    //                       </span>
    //                     </span>
    //                   </div>
    //                 </div>
    //                 <div className="casino-table-right-box ng-tns-c3502172659-1">
    //                   <div className="lucky7odds ng-tns-c3502172659-1 ng-star-inserted">
    //                     <div className="casino-odds text-center ng-tns-c3502172659-1">
    //                       {getOddForEntity("red", casinoData)}
    //                     </div>
    //                     <div
    //                       onClick={() => setBet("red", casinoData, dispatch)}
    //                       className={`ng-tns-c3502172659-1 back casino-odds-box casino-odds-box-theme ${casinoData
    //                         ?.data?.response?.autoTime < 5 && "suspended-box"}`}
    //                     >
    //                       <span className="casino-odds ng-tns-c3502172659-1">
    //                         <span className="card-icon ms-1 ng-tns-c3502172659-1">
    //                           <span className="card-red ng-tns-c3502172659-1">
    //                             <img
    //                               className="ng-tns-c3502172659-1"
    //                               src="https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/heart.png"
    //                             />
    //                           </span>
    //                         </span>
    //                         <span className="card-icon ms-1 ng-tns-c3502172659-1">
    //                           <span className="card-red ng-tns-c3502172659-1">
    //                             <img
    //                               className="ng-tns-c3502172659-1"
    //                               src="https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/diamond.png"
    //                             />
    //                           </span>
    //                         </span>
    //                       </span>
    //                     </div>
    //                     <div className="casino-nation-book text-center ng-tns-c3502172659-1">
    //                       {getCasinoPlExposureByRunner(casinoPlData, "Red")}
    //                     </div>
    //                   </div>

    //                   <div className="lucky7odds ng-tns-c3502172659-1 ng-star-inserted">
    //                     <div className="casino-odds text-center ng-tns-c3502172659-1">
    //                       {getOddForEntity("black", casinoData)}
    //                     </div>
    //                     <div
    //                       onClick={() => setBet("black", casinoData, dispatch)}
    //                       className={`ng-tns-c3502172659-1 back casino-odds-box casino-odds-box-theme ${casinoData
    //                         ?.data?.response?.autoTime < 5 && "suspended-box"}`}
    //                     >
    //                       <span className="casino-odds ng-tns-c3502172659-1">
    //                         <span className="card-icon ms-1 ng-tns-c3502172659-1">
    //                           <span className="card-red ng-tns-c3502172659-1">
    //                             <img
    //                               className="ng-tns-c3502172659-1"
    //                               src="https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/spade.png"
    //                             />
    //                           </span>
    //                         </span>
    //                         <span className="card-icon ms-1 ng-tns-c3502172659-1">
    //                           <span className="card-red ng-tns-c3502172659-1">
    //                             <img
    //                               className="ng-tns-c3502172659-1"
    //                               src="https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/club.png"
    //                             />
    //                           </span>
    //                         </span>
    //                       </span>
    //                     </div>
    //                     <div className="casino-nation-book text-center ng-tns-c3502172659-1">
    //                       {getCasinoPlExposureByRunner(casinoPlData, "Black")}
    //                     </div>
    //                   </div>

    //                   <div className="min_max_odds ng-tns-c3502172659-1 ng-star-inserted">
    //                     <span className="min_max_span ng-tns-c3502172659-1">
    //                       <b className="ng-tns-c3502172659-1">Min:</b>
    //                       <span className="ng-tns-c3502172659-1"> 100</span>
    //                     </span>
    //                     <span className="min_max_span ng-tns-c3502172659-1">
    //                       <b className="ng-tns-c3502172659-1">Max:</b>
    //                       <span className="ng-tns-c3502172659-1">
    //                         <span className="ng-tns-c3502172659-1 ng-star-inserted">
    //                           {" "}
    //                           25000{" "}
    //                         </span>
    //                       </span>
    //                     </span>
    //                   </div>
    //                 </div>
    //               </div>
    //               <PlaceBet GAME_ID={GAME_ID} />
    //               <div className="casino-table-full-box lucky7acards mt-3 ng-tns-c3502172659-1">
    //                 <div className="casino-odds w-100 text-center ng-tns-c3502172659-1">
    //                   {" "}
    //                   12{" "}
    //                 </div>

    //                 {CARD_ARRAY.map((card, index) => (
    //                   <div
    //                     onClick={() =>
    //                       setBet("card " + card, casinoData, dispatch)
    //                     }
    //                     className="card-odd-box ng-tns-c3502172659-1 ng-star-inserted"
    //                   >
    //                     <div
    //                       className={`ng-tns-c3502172659-1 ${casinoData?.data
    //                         ?.response?.autoTime < 5 && "suspended-box"}`}
    //                     >
    //                       <img
    //                         className="ng-tns-c3502172659-1 ng-star-inserted"
    //                         src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${card}.png`}
    //                       />
    //                     </div>
    //                     <div className="casino-nation-book ng-tns-c3502172659-1">
    //                       {getCasinoPlExposureByRunner(
    //                         casinoPlData,
    //                         "Card " + card
    //                       )}
    //                     </div>
    //                   </div>
    //                 ))}

    //                 <div className="min_max_odds ng-tns-c3502172659-1 ng-star-inserted">
    //                   <span className="min_max_span ng-tns-c3502172659-1">
    //                     <b className="ng-tns-c3502172659-1">Min:</b>
    //                     <span className="ng-tns-c3502172659-1"> 100</span>
    //                   </span>
    //                   <span className="min_max_span ng-tns-c3502172659-1">
    //                     <b className="ng-tns-c3502172659-1">Max:</b>
    //                     <span className="ng-tns-c3502172659-1">
    //                       <span className="ng-tns-c3502172659-1 ng-star-inserted">
    //                         {" "}
    //                         25000{" "}
    //                       </span>
    //                     </span>
    //                   </span>
    //                 </div>
    //               </div>
    //             </div>

    //             <div className="ng-tns-c3502172659-1">
    //               <div className="casino-last-result-title ng-tns-c3502172659-1">
    //                 <span className="ng-tns-c3502172659-1">Last Result</span>
    //                 <span className="ng-tns-c3502172659-1">
    //                   <a className="ng-tns-c3502172659-1">View All</a>
    //                 </span>
    //               </div>
    //               <div className="casino-last-results ng-tns-c3502172659-1 ng-star-inserted">
    //                 {lastTenResultData?.data?.data?.casinoMarketHistoryResponseDTOS?.map(
    //                   (item) => (
    //                     <span
    //                       className={`ng-tns-c3502172659-1 result result-${
    //                         item?.mainWinner == "T"
    //                           ? "c"
    //                           : item?.mainWinner == "L"
    //                           ? "a"
    //                           : "b"
    //                       } ng-star-inserted`}
    //                     >
    //                       <span className="ng-tns-c3502172659-1">
    //                         {" "}
    //                         {item?.mainWinner}
    //                       </span>
    //                     </span>
    //                   )
    //                 )}
    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       ) : (
    //         <PlacedBet bets={casinoBets?.data?.response} />
    //       )}
    //       <div className="ng-tns-c3502172659-1 d-none matchbettable w-100 ng-star-inserted">
    //         <div className="table-responsive ng-tns-c3502172659-1">
    //           <table className="table ng-tns-c3502172659-1">
    //             <thead className="ng-tns-c3502172659-1">
    //               <tr className="ng-tns-c3502172659-1">
    //                 <th className="ng-tns-c3502172659-1">Matched Bet</th>
    //                 <th className="text-end ng-tns-c3502172659-1">Odds</th>
    //                 <th className="text-end ng-tns-c3502172659-1">Stake</th>
    //               </tr>
    //             </thead>
    //           </table>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <div className="sidebar right-sidebar casino-right-sidebar ng-tns-c3502172659-1">
    //     <div className="sidebar-box place-bet-container d-xl-block d-none ng-tns-c3502172659-1">
    //       <div className="sidebar-title ng-tns-c3502172659-1">
    //         <h4 className="ng-tns-c3502172659-1">Place Bet</h4>
    //       </div>
    //     </div>
    //     <div className="sidebar-box my-bet-container d-xl-block d-none ng-tns-c3502172659-1">
    //       <div className="sidebar-title ng-tns-c3502172659-1">
    //         <h4 className="ng-tns-c3502172659-1">My Bet</h4>
    //         <a className="sideviewmore ng-tns-c3502172659-1">View more</a>
    //       </div>
    //       <div className="my-bets ng-tns-c3502172659-1">
    //         <div className="table-responsive w-100 ng-tns-c3502172659-1">
    //           <table className="table ng-tns-c3502172659-1">
    //             <thead className="ng-tns-c3502172659-1">
    //               <tr className="ng-tns-c3502172659-1">
    //                 <th className="ng-tns-c3502172659-1">Matched Bet</th>
    //                 <th className="text-end ng-tns-c3502172659-1">Odds</th>
    //                 <th className="text-end ng-tns-c3502172659-1">Stake</th>
    //               </tr>
    //             </thead>
    //           </table>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="sidebar-box sidebar-box-rules my-bet-container ng-tns-c3502172659-1">
    //       <app-casino-game-rules
    //         className="ng-tns-c3502172659-1"
    //         _nghost-ng-c1761710207=""
    //       />
    //     </div>
    //   </div>
    //   {showRules && (
    //     <>
    //       <div class="fade modal-backdrop show" />
    //       <div
    //         role="dialog"
    //         aria-modal="true"
    //         className="fade modal show"
    //         tabIndex={-1}
    //         style={{ display: "block" }}
    //       >
    //         <div className="modal-dialog modal-lg">
    //           <div className="modal-content">
    //             <div className="modal-header">
    //               <div className="modal-title h4"> Rules</div>
    //               <button
    //                 onClick={() => {
    //                   setShowRules(false);
    //                 }}
    //                 type="button"
    //                 className="btn-close"
    //                 aria-label="Close"
    //               />
    //             </div>
    //             {showRules && (
    //               <>
    //                 <div class="fade modal-backdrop show" />
    //                 <div
    //                   role="dialog"
    //                   aria-modal="true"
    //                   className="fade modal show"
    //                   tabIndex={-1}
    //                   style={{ display: "block" }}
    //                 >
    //                   <div className="modal-dialog modal-lg">
    //                     <div className="modal-content">
    //                       <div className="modal-header">
    //                         <div className="modal-title h4">Rules</div>
    //                         <button
    //                           onClick={() => {
    //                             setShowRules(false);
    //                           }}
    //                           type="button"
    //                           className="btn-close"
    //                           aria-label="Close"
    //                         />
    //                       </div>
    //                       <div className="modal-body">
    //                         <div>
    //                           <style
    //                             type="text/css"
    //                             dangerouslySetInnerHTML={{
    //                               __html:
    //                                 '\n        .rules-section .row.row5 {\n            margin-left: -5px;\n            margin-right: -5px;\n        }\n        .rules-section .pl-2 {\n            padding-left: .5rem !important;\n        }\n        .rules-section .pr-2 {\n            padding-right: .5rem !important;\n        }\n        .rules-section .row.row5 > [class*="col-"], .rules-section .row.row5 > [class*="col"] {\n            padding-left: 5px;\n            padding-right: 5px;\n        }\n        .rules-section\n        {\n            text-align: left;\n            margin-bottom: 10px;\n        }\n        .rules-section .table\n        {\n            color: #fff;\n            border:1px solid #444;\n            background-color: #222;\n            font-size: 12px;\n        }\n        .rules-section .table td, .rules-section .table th\n        {\n            border-bottom: 1px solid #444;\n        }\n        .rules-section ul li, .rules-section p\n        {\n            margin-bottom: 5px;\n        }\n        .rules-section::-webkit-scrollbar {\n            width: 8px;\n        }\n        .rules-section::-webkit-scrollbar-track {\n            background: #666666;\n        }\n\n        .rules-section::-webkit-scrollbar-thumb {\n            background-color: #333333;\n        }\n        .rules-section .rules-highlight\n        {\n            color: #FDCF13;\n            font-size: 16px;\n        }\n        .rules-section .rules-sub-highlight {\n            color: #FDCF13;\n            font-size: 14px;\n        }\n        .rules-section .list-style, .rules-section .list-style li\n        {\n            list-style: disc;\n        }\n        .rules-section .rule-card\n        {\n            height: 20px;\n            margin-left: 5px;\n        }\n        .rules-section .card-character\n        {\n            font-family: Card Characters;\n        }\n        .rules-section .red-card\n        {\n            color: red;\n        }\n        .rules-section .black-card\n        {\n            color: black;\n        }\n        .rules-section .cards-box\n        {\n            background: #fff;\n            padding: 6px;\n            display: inline-block;\n            color: #000;\n            min-width: 150px;\n        }\n    ',
    //                             }}
    //                           />
    //                           <div className="rules-section">
    //                             <ul className="pl-4 pr-4 list-style">
    //                               <li>
    //                                 Lucky 7 is a 8 deck playing cards game,
    //                                 total 8 * 52 = 416 cards.
    //                               </li>
    //                               <li>
    //                                 If the card is from ACE to 6, LOW Wins.
    //                               </li>
    //                               <li>
    //                                 If the card is from 8 to KING, HIGH Wins.
    //                               </li>
    //                               <li>
    //                                 If the card is 7, bets on high and low will
    //                                 lose 50% of the bet amount.
    //                               </li>
    //                             </ul>
    //                             <div>
    //                               <b className="rules-sub-highlight">LOW:</b>
    //                               1,2,3,4,5,6 |{" "}
    //                               <b className="rules-sub-highlight">HIGH:</b>
    //                               8,9,10,J,Q,K
    //                             </div>
    //                             <div>Payout:2.0</div>
    //                             <br />
    //                             <div>
    //                               <b className="rules-sub-highlight">EVEN:</b>
    //                               2,4,6,8,10,Q
    //                             </div>
    //                             <div>Payout:2.10</div>
    //                             <br />
    //                             <div>
    //                               <b className="rules-sub-highlight">ODD:</b>
    //                               1,3,5,7,9,J,K
    //                             </div>
    //                             <div>Payout:1.79</div>
    //                             <br />
    //                             <div>
    //                               <b className="rules-sub-highlight">RED:</b>
    //                             </div>
    //                             <div>Payout:1.95</div>
    //                             <br />
    //                             <div>
    //                               <b className="rules-sub-highlight">BLACK:</b>
    //                             </div>
    //                             <div>Payout:1.95</div>
    //                             <br />
    //                             <b className="rules-sub-highlight">CARDS:</b>
    //                             1,2,3,4,5,6,7,8,9,10,J,Q,K
    //                             <div>PAYOUT: 12.0</div>
    //                           </div>{" "}
    //                         </div>
    //                       </div>
    //                     </div>
    //                   </div>
    //                 </div>
    //               </>
    //             )}
    //           </div>
    //         </div>
    //       </div>
    //     </>
    //   )}
    // </div>
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={CASINO_VIDEO.lucky7A}
      GAME_ID={GAME_ID}
      gameName={"Lucky 7 - A"}
      shortName="lucky7acards"
    >
      <div className="casino-table">
        <div
          className="casino-table-full-box"
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <div className="lucky7low" style={{ width: "45%", height: "100%" }}>
            <div className="casino-odds text-center">
              {getOddForEntity("LOW Card", casinoData)}
            </div>
            <div
              className={`casino-odds-box back casino-odds-box-theme ${
                casinoData?.data?.response?.autoTime < 5
                  ? "suspended-box"
                  : ""
              }`}
              onClick={() => setBet("LOW Card", casinoData, dispatch, "back")}
            >
              <span className="casino-odds" style={{ padding: "20px" }}>
                Low Card
              </span>
            </div>
            <div className="casino-nation-book text-center">
              {getCasinoPlExposureByRunner(casinoPlData, "LOW Card")}
            </div>
          </div>
          <div className="lucky7">
            <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/7.png" />
          </div>
          <div
            className=" lucky7high"
            style={{ width: "45%", height: "100%" }}
          >
            <div className="casino-odds text-center">
              {" "}
              {getOddForEntity("HIGH Card", casinoData)}
            </div>
            <div
              className={`casino-odds-box back casino-odds-box-theme ${
                casinoData?.data?.response?.autoTime < 5
                  ? "suspended-box"
                  : ""
              }`}
              onClick={() =>
                setBet("HIGH Card", casinoData, dispatch, "back")
              }
            >
              <span className="casino-odds" style={{ padding: "20px" }}>
                High Card
              </span>
            </div>
            <div className="casino-nation-book text-center">
              {getCasinoPlExposureByRunner(casinoPlData, "HIGH Card")}
            </div>
          </div>
        </div>
        <div className="casino-table-box mt-3">
          <div
            className="casino-table-left-box"
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              // width: "100%",
              justifyContent: "center",
            }}
          >
            <div className="lucky7odds" style={{ width: "45%" }}>
              <div className="casino-odds text-center">
                {" "}
                {getOddForEntity("Even", casinoData)}
              </div>
              <div
                className={`casino-odds-box back casino-odds-box-theme ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Even", casinoData, dispatch, "back")}
              >
                <span className="casino-odds" style={{ padding: "15px" }}>
                  Even
                </span>
              </div>
              <div className="casino-nation-book text-center">
                {getCasinoPlExposureByRunner(casinoPlData, "Even")}
              </div>
            </div>
            <div className=" lucky7odds" style={{ width: "45%" }}>
              <div className="casino-odds text-center">
                {" "}
                {getOddForEntity("Odd", casinoData)}
              </div>
              <div
                className={`casino-odds-box back casino-odds-box-theme ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Odd", casinoData, dispatch, "back")}
              >
                <span className="casino-odds" style={{ padding: "15px" }}>
                  Odd
                </span>
              </div>
              <div className="casino-nation-book text-center">
                {getCasinoPlExposureByRunner(casinoPlData, "Odd")}
              </div>
            </div>
          </div>
          <div
            className="casino-table-right-box"
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              // width: "100%",
              justifyContent: "center",
            }}
          >
            <div className=" lucky7odds" style={{ width: "45%" }}>
              <div className="casino-odds text-center">
                {" "}
                {getOddForEntity("Red", casinoData)}
              </div>
              <div
                className={`casino-odds-box back casino-odds-box-theme ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Red", casinoData, dispatch, "back")}
              >
                <span className="casino-odds" style={{ padding: "15px" }}>
                  <span
                    _ngcontent-ng-c1798067373=""
                    className="card-red ng-tns-c1798067373-0"
                    data-v-53a3d43f=""
                  >
                    <img
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-0"
                      src="https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/heart.png"
                      data-v-53a3d43f=""
                      style={{ width: "18px", height: "18px" }}
                    />
                  </span>{" "}
                  <span
                    _ngcontent-ng-c1798067373=""
                    className="card-red ng-tns-c1798067373-0"
                    data-v-53a3d43f=""
                  >
                    <img
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-0"
                      src="https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/diamond.png"
                      data-v-53a3d43f=""
                      style={{ width: "18px", height: "18px" }}
                    />
                  </span>
                  {/* <span className="card-icon ms-1">
                    <span className="card-red ">[</span>
                  </span> */}
                </span>
              </div>
              <div className="casino-nation-book text-center">
                {getCasinoPlExposureByRunner(casinoPlData, "Red")}
              </div>
            </div>
            <div className=" lucky7odds" style={{ width: "45%" }}>
              <div className="casino-odds text-center">
                {" "}
                {getOddForEntity("Black", casinoData)}
              </div>
              <div
                className={`casino-odds-box back casino-odds-box-theme ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Black", casinoData, dispatch, "back")}
              >
                <span className="casino-odds" style={{ padding: "15px" }}>
                  <span
                    _ngcontent-ng-c1798067373=""
                    className="card-red ng-tns-c1798067373-0"
                    data-v-53a3d43f=""
                  >
                    <img
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-0"
                      src="https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/spade.png"
                      data-v-53a3d43f=""
                      style={{ width: "18px", height: "18px" }}
                    />
                  </span>
                  <span
                    _ngcontent-ng-c1798067373=""
                    className="card-red ng-tns-c1798067373-0"
                    data-v-53a3d43f=""
                  >
                    <img
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-0"
                      src="https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/club.png"
                      data-v-53a3d43f=""
                      style={{ width: "18px", height: "18px" }}
                    />
                  </span>
                </span>
              </div>
              <div className="casino-nation-book text-center">
                {getCasinoPlExposureByRunner(casinoPlData, "Black")}
              </div>
            </div>
          </div>
        </div>
        <div className="casino-table-box mt-3">
          <div
            className="lucky7cards"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="casino-odds w-100 text-center">
              {" "}
              {getOddForEntity("Line 1", casinoData)}
            </div>
            <div
              className={`card-odd-box-container ${
                casinoData?.data?.response?.autoTime < 5
                  ? "suspended-box"
                  : ""
              }`}
              onClick={() => setBet("Line 1", casinoData, dispatch, "back")}
            >
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/A.png" />
                </div>
              </div>
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/2.png" />
                </div>
              </div>
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/3.png" />
                </div>
              </div>
            </div>
            <div className="casino-nation-book text-center">
              {getCasinoPlExposureByRunner(casinoPlData, "Line 1")}
            </div>
          </div>
          <div
            className="lucky7cards"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="casino-odds w-100 text-center">
              {" "}
              {getOddForEntity("Line 2", casinoData)}
            </div>
            <div
              className={`card-odd-box-container ${
                casinoData?.data?.response?.autoTime < 5
                  ? "suspended-box"
                  : ""
              }`}
              onClick={() => setBet("Line 2", casinoData, dispatch, "back")}
            >
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/4.png" />
                </div>
              </div>
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/5.png" />
                </div>
              </div>
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/6.png" />
                </div>
              </div>
            </div>
            <div className="casino-nation-book text-center">
              {getCasinoPlExposureByRunner(casinoPlData, "Line 2")}
            </div>
          </div>
          <div
            className="lucky7cards"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="casino-odds w-100 text-center">
              {getOddForEntity("Line 3", casinoData)}
            </div>
            <div
              className={`card-odd-box-container ${
                casinoData?.data?.response?.autoTime < 5
                  ? "suspended-box"
                  : ""
              }`}
              onClick={() => setBet("Line 3", casinoData, dispatch, "back")}
            >
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/8.png" />
                </div>
              </div>
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/9.png" />
                </div>
              </div>
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/10.png" />
                </div>
              </div>
            </div>
            <div className="casino-nation-book text-center">
              {getCasinoPlExposureByRunner(casinoPlData, "Line 3")}
            </div>
          </div>
          <div
            className="lucky7cards"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="casino-odds w-100 text-center">
              {getOddForEntity("Line 4", casinoData)}
            </div>
            <div
              className={`card-odd-box-container ${
                casinoData?.data?.response?.autoTime < 5
                  ? "suspended-box"
                  : ""
              }`}
              onClick={() => setBet("Line 4", casinoData, dispatch, "back")}
            >
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/J.png" />
                </div>
              </div>
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/Q.png" />
                </div>
              </div>
              <div className="card-odd-box">
                <div className="">
                  <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/K.png" />
                </div>
              </div>
            </div>
            <div className="casino-nation-book text-center">
              {getCasinoPlExposureByRunner(casinoPlData, "Line 4")}
            </div>
          </div>
        </div>

        <div className="casino-table-full-box lucky7acards mt-3">
          <div className="casino-odds w-100 text-center">
            {" "}
            {getOddForEntity("Card 1", casinoData)}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-around",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 1", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/A.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 1")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 2", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/2.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 2")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 3", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/3.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 3")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 4", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/4.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 4")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 5", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/5.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 5")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 6", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/6.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 6")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 7", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/7.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 7")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 8", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/8.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 8")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card 9", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/9.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 9")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Card 10", casinoData, dispatch, "back")
                }
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/10.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card 10")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card J", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/J.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card J")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card Q", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/Q.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card Q")}
              </div>
            </div>
            <div className="card-odd-box">
              <div
                className={` ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Card K", casinoData, dispatch, "back")}
              >
                <img src="https://versionobj.ecoassetsservice.com/v24/static/front/img/cards/K.png" />
              </div>
              <div className="casino-nation-book">
                {getCasinoPlExposureByRunner(casinoPlData, "Card K")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </CasinoPage>
  );
}
